import { Domain, Locale } from '../types';

/**
 * Получает хост на клиенте
 */
export const getClientHost = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.location.host;
};

/**
 * Универсальная функция для проверки домена по коду страны
 */
export const isDomain = (host: string | null, code: Domain): boolean => {
  if (!host) {
    return false;
  }
  const lowerCode = code.toLowerCase();

  return (
    host.endsWith(`.${lowerCode}`) ||
    host.includes(`dev-2gis-${lowerCode}.istio.k8s.2gis.dev`) ||
    host.includes(`.local.${lowerCode}`) ||
    (lowerCode === 'ru' &&
      (host === 'localhost' || host.startsWith('localhost:')))
  );
};

/**
 * Проверяет, является ли домен русским (.ru)
 */
export const isRuDomain = (host: string | null): boolean =>
  isDomain(host, 'ru') || !!host?.includes('dev-2gis.istio.k8s.2gis.dev');

/**
 * Проверяет, является ли домен казахстанским (.kz)
 */
export const isKzDomain = (host: string | null): boolean =>
  isDomain(host, 'kz');

/**
 * Проверяет, является ли домен армянским (.am)
 */
export const isAmDomain = (host: string | null): boolean =>
  isDomain(host, 'am');

/**
 * Проверяет, является ли домен грузинским (.ge)
 */
export const isGeDomain = (host: string | null): boolean =>
  isDomain(host, 'ge');

/**
 * Проверяет, является ли домен международным (.com)
 */
export const isComDomain = (host: string | null): boolean =>
  isDomain(host, 'com');

/**
 * Проверяет, является ли домен таджикским (.tg)
 */
export const isTgDomain = (host: string | null): boolean =>
  isDomain(host, 'tj');

export const getDomainKey = (clientHost: string | null): Domain => {
  if (isKzDomain(clientHost)) {
    return 'kz';
  }

  if (isAmDomain(clientHost)) {
    return 'am';
  }

  if (isComDomain(clientHost)) {
    return 'com';
  }

  if (isTgDomain(clientHost)) {
    return 'tj';
  }

  if (isGeDomain(clientHost)) {
    return 'ge';
  }

  return 'ru';
};

export const getLocaleByDomain = (clientHost: string | null): Locale => {
  if (isKzDomain(clientHost)) {
    return 'kz';
  }

  if (isAmDomain(clientHost)) {
    return 'am';
  }

  if (isComDomain(clientHost)) {
    return 'en';
  }

  if (isTgDomain(clientHost)) {
    return 'tg';
  }

  if (isGeDomain(clientHost)) {
    return 'ge';
  }

  return 'ru';
};
